export default __webpack_public_path__ + "static/media/education.9b28b772.jpg";